import { useCallback, useRef, useState } from '@redneckz/uni-jsx/lib/hooks';
import { areArraysEqual } from '../../utils/areArraysEqual.js';
import { maxBy } from '../../utils/maxBy.js';
import { minBy } from '../../utils/minBy.js';
import { scrollBy } from './scrollBy.js';
import { scrollToEnd } from './scrollToEnd.js';
import { scrollToStart } from './scrollToStart.js';
export const useSwipeListScroll = ({ itemCount, onVisibleIndicesChange, }) => {
    const containerRef = useRef(null);
    const [visibleIndices, setVisibleIndices] = useState([]);
    const handleVisibleIndicesChange = useCallback((indices) => {
        setVisibleIndices((prevIndices) => areArraysEqual(prevIndices, indices) ? prevIndices : indices);
        onVisibleIndicesChange && onVisibleIndicesChange(indices);
    }, [onVisibleIndicesChange]);
    const [minIndex, maxIndex] = visibleIndices.length
        ? [minBy()(visibleIndices), maxBy()(visibleIndices)]
        : [-1, -1];
    const canScrollLeft = minIndex > 0;
    const canScrollRight = maxIndex < itemCount - 1;
    const scrollLeft = useCallback(() => {
        if (!containerRef.current) {
            return;
        }
        if (canScrollLeft) {
            scrollBy(containerRef.current)(itemCount, -1);
        }
        else {
            scrollToEnd(containerRef.current);
        }
    }, [itemCount, canScrollLeft]);
    const scrollRight = useCallback(() => {
        if (!containerRef.current) {
            return;
        }
        if (canScrollRight) {
            scrollBy(containerRef.current)(itemCount, 1);
        }
        else {
            scrollToStart(containerRef.current);
        }
    }, [itemCount, canScrollRight]);
    const scrollTo = useCallback((idx, options = {
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
    }) => {
        if (containerRef?.current) {
            containerRef.current.children[idx]?.scrollIntoView(options);
        }
    }, [containerRef]);
    return [
        containerRef,
        {
            scrollLeft,
            scrollRight,
            scrollTo,
            canScrollLeft,
            canScrollRight,
            visibleIndicesRange: [minIndex, maxIndex],
            handleVisibleIndicesChange,
        },
    ];
};
//# sourceMappingURL=useSwipeListScroll.js.map